import { render, staticRenderFns } from "./SolicitacaoDesenvolvimento.vue?vue&type=template&id=4cf77027&"
import script from "./SolicitacaoDesenvolvimento.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoDesenvolvimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports